import { RouteConfig, Route, NavigationGuardNext } from "vue-router";
const tabOneWelcome = () => import("./quote/views/tab-one.vue");
const destinationView = () => import("./quote/views/destination.vue");
const tripTypeView = () => import("./quote/views/trip-type.vue");
const tabTwoTravelDetails = () => import("./quote/views/tab-two.vue");
const tabThreePlans = () => import("./quote/views/tab-three.vue");
const policyOwner = () => import("./quote/tabsClient/policyOwner.vue");
const passengers = () => import("./quote/tabsClient/passengers.vue");
const travelSummary = () => import("./quote/travelSummary.vue");
const finalPayment = () => import("./quote/finalPayment.vue");
const pageTitle = 'Cotizá tu Asistencia al Viajero | Sancor Seguros';
const contentMetaData = 'Cotizá tu seguro de asistencia al viajero de manera rápida y sencilla. Compará planes y encontrá la cobertura ideal para tu próximo viaje.'

const routes: Array<RouteConfig> = [
    {
        path: "/asistencia-viajero/destino",
        name: "travelAssistance-destination",
        component: destinationView,
        meta: {
            title: () => '¿A dónde viajás?',
            pageTitle: pageTitle,
            metaTags: [
                {
                    name: 'description',
                    content: contentMetaData
                },
            ]
        },
    },
    {
        path: "/asistencia-viajero/tipo-viaje",
        name: "travelAssistance-trip-type",
        component: tripTypeView,
        meta: {
            title: () => 'Tipo de viaje',
            pageTitle: pageTitle,
            metaTags: [
                {
                    name: 'description',
                    content: contentMetaData
                },
            ]
        },
    },
    {
        path: "/asistencia-viajero/datos-viaje",
        name: "travelAssistance-tab-two",
        component: tabTwoTravelDetails,
        meta: {
            title: () => 'Datos del Viaje',
            pageTitle: pageTitle,
            metaTags: [
                {
                    name: 'description',
                    content: contentMetaData
                },
            ]
        },
    },
    {
        path: "/asistencia-viajero/plan",
        name: "travelAssistance-tab-three",
        component: tabThreePlans,
        meta: {
            title: () => 'Elegí el Plan',
            pageTitle: pageTitle,
            metaTags: [
                {
                    name: 'description',
                    content: contentMetaData
                },
            ]
        },
    },
    {
        path: "/asistencia-viajero/contratante",
        name: "travelAssistance-policyOwner",
        component: policyOwner,
        meta: {
            title: () => 'Datos del Contratante',
            pageTitle: pageTitle,
            metaTags: [
                {
                    name: 'description',
                    content: contentMetaData
                },
            ]
        },
    },
    {
        path: "/asistencia-viajero/pasajeros",
        name: "travelAssistance-passengers",
        component: passengers,
        meta: {
            title: () => 'Datos de los Pasajeros',
            pageTitle: pageTitle,
            metaTags: [
                {
                    name: 'description',
                    content: contentMetaData
                },
            ]
        },
    },
    {
        path: "/asistencia-viajero/resumen",
        name: "travelAssistance-Summary",
        component: travelSummary,
        meta: {
            title: () => 'Resumen',
            pageTitle: pageTitle,
            metaTags: [
                {
                    name: 'description',
                    content: contentMetaData
                },
            ]
        },
    },
    {
        path: "/asistencia-viajero/finContrato",
        name: "travelAssistance-FinalPayment",
        component: finalPayment,
        meta: {
            pageTitle: pageTitle,
            metaTags: [
                {
                    name: 'description',
                    content: contentMetaData
                },
            ]
        },
        beforeEnter: (to: Route, from: Route, next: NavigationGuardNext): void => {
            const { ParamId, ExternalIdentifier, ChannelId } = to.query as {
                ParamId?: string;
                ExternalIdentifier?: string;
                ChannelId?: string;
            };

            if (ParamId || ExternalIdentifier || ChannelId) {
                if (ParamId) {
                    sessionStorage.setItem("ParamId", ParamId);
                }
                if (ExternalIdentifier) {
                    sessionStorage.setItem("PricingId", ExternalIdentifier);
                }
                if (ChannelId) {
                    sessionStorage.setItem("ChannelId", ChannelId);
                }

                sessionStorage.setItem("ExitOrContinueModal", "false");

                const timeStart = new Date();
                sessionStorage.setItem("TimeStartPaymentComplete", JSON.stringify(timeStart));

                next({ path: to.path, query: {} });
            } else {
                next();
            }
        }
    },
    // Ruta comodín debe ir al final siempre
    {
        path: "/asistencia-viajero/:subpath*",
        name: "travelAssistance-tab-One",
        component: tabOneWelcome,
        meta: {
            title: () => 'Datos personales',
            pageTitle: pageTitle,
            metaTags: [
                {
                    name: 'description',
                    content: contentMetaData
                },
            ]
        },
        beforeEnter: (to: Route, from: Route, next: NavigationGuardNext): void => {
            const { utm_source } = to.query as { utm_source?: string };

            const existente = sessionStorage.getItem("Referente");
            if (!existente) {
                if (utm_source) {
                    sessionStorage.setItem("Referente", utm_source);
                }
                else {
                    if (document.referrer != '') {
                        sessionStorage.setItem("Referente", document.referrer);
                    }
                    else {
                        sessionStorage.setItem("Referente", null);
                    }
                }
            }

            const { utm_medium } = to.query as { utm_medium?: string };

            const existente_medium = sessionStorage.getItem("Medium");
            if (!existente_medium) {
                if (utm_medium) {
                    sessionStorage.setItem("Medium", utm_medium);
                }
                else {
                    sessionStorage.setItem("Medium", 'organic');
                }
            }

            // Gate temporal de pruebas: RedirectToHome (tab-one) lee ?test de la URL, así que al limpiar
            // la query se conserva 'test'. Cuando el producto salga a público, volver a limpiar todo.
            const { test } = to.query as { test?: string };
            const cleanQuery = test ? { test } : {};
            if (Object.keys(to.query).length > Object.keys(cleanQuery).length) {
                next({ path: to.path, query: cleanQuery });
            } else {
                next();
            }
        }
    },
];

export default routes;
